import { render } from "./ShowRights.vue?vue&type=template&id=ad3411de&scoped=true"
import script from "./ShowRights.vue?vue&type=script&lang=js"
export * from "./ShowRights.vue?vue&type=script&lang=js"

import "./ShowRights.vue?vue&type=style&index=0&id=ad3411de&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad3411de"]])

export default __exports__